import { render, staticRenderFns } from "./KeywordTable.vue?vue&type=template&id=7787a0c2&"
import script from "./KeywordTable.vue?vue&type=script&lang=js&"
export * from "./KeywordTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports